import * as React from 'react';
import { Spinner } from '../../components/Spinner/index.js';
export function Loader(_a) {
    var loading = _a.loading, data = _a.data, children = _a.children;
    if (loading) {
        return React.createElement(Spinner, null);
    }
    else if (data instanceof Error) {
        return children(undefined, data);
    }
    else {
        return children(data, undefined);
    }
}
//# sourceMappingURL=index.js.map